"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withController = exports.useController = exports.ControllerProvider = void 0;
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var ControllerContext = (0, preact_1.createContext)(null);
var ControllerProvider = function (_a) {
    var children = _a.children, controller = _a.controller;
    return (0, preact_1.h)(ControllerContext.Provider, { value: controller }, children);
};
exports.ControllerProvider = ControllerProvider;
var useController = function () { return (0, hooks_1.useContext)(ControllerContext); };
exports.useController = useController;
var withController = function (Component) { return function (props) {
    return (0, preact_1.h)(Component, __assign({ controller: (0, exports.useController)() }, props));
}; };
exports.withController = withController;
